export default "__VITE_ASSET__r9kMTN8m__"